/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourdrafthasbeenclearedsuccessfully5Inputs */

const en_yourdrafthasbeenclearedsuccessfully5 = /** @type {(inputs: Yourdrafthasbeenclearedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your draft has been cleared successfully.`)
};

const de_yourdrafthasbeenclearedsuccessfully5 = /** @type {(inputs: Yourdrafthasbeenclearedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Entwurf wurde gelöscht.`)
};

/**
* | output |
* | --- |
* | "Your draft has been cleared successfully." |
*
* @param {Yourdrafthasbeenclearedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourdrafthasbeenclearedsuccessfully5 = /** @type {((inputs?: Yourdrafthasbeenclearedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourdrafthasbeenclearedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourdrafthasbeenclearedsuccessfully5(inputs)
	return de_yourdrafthasbeenclearedsuccessfully5(inputs)
});
export { yourdrafthasbeenclearedsuccessfully5 as "yourDraftHasBeenClearedSuccessfully" }